import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Checkbox } from '../ui/checkbox';
import { Plus, Trash2, Eye, EyeOff } from 'lucide-react';

export const KeyValueEditor = ({ 
  items, 
  onChange, 
  secretField = false, 
  placeholder = { key: 'Key', value: 'Value' } 
}) => {
  const addItem = () => {
    onChange([...items, { key: '', value: '', enabled: true, is_secret: false }]);
  };
  
  const updateItem = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;
    onChange(updated);
  };
  
  const removeItem = (index) => {
    onChange(items.filter((_, i) => i !== index));
  };
  
  return (
    <div className="space-y-2">
      {items.map((item, index) => (
        <div key={index} className="flex items-center gap-2">
          <Checkbox
            checked={item.enabled !== false}
            onCheckedChange={(c) => updateItem(index, 'enabled', c)}
          />
          <Input
            value={item.key}
            onChange={(e) => updateItem(index, 'key', e.target.value)}
            placeholder={placeholder.key}
            className="flex-1"
          />
          <Input
            type={item.is_secret ? 'password' : 'text'}
            value={item.value}
            onChange={(e) => updateItem(index, 'value', e.target.value)}
            placeholder={placeholder.value}
            className="flex-1"
          />
          {secretField && (
            <Button
              variant="ghost"
              size="icon"
              onClick={() => updateItem(index, 'is_secret', !item.is_secret)}
              title={item.is_secret ? 'Mostrar' : 'Ocultar'}
            >
              {item.is_secret ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </Button>
          )}
          <Button variant="ghost" size="icon" onClick={() => removeItem(index)}>
            <Trash2 className="h-4 w-4 text-red-500" />
          </Button>
        </div>
      ))}
      <Button variant="outline" size="sm" onClick={addItem} className="w-full">
        <Plus className="h-4 w-4 mr-2" /> Agregar
      </Button>
    </div>
  );
};

export default KeyValueEditor;
